import React from 'react';
import '../../../App.css';
import CardItem from '../../CardItem';
import Footer from '../../Footer';
import {
  dunesJpg,
  dunes2Jpg,
  beverlyHillsJpg,
  qatamyaHeightsJpg,
  heightsJpg,
  domesticControlRoomJpg,
} from '../../../images/assets';

function laptopProjects() {
  return (
    <>
        <div style={{backgroundColor:'rgb(248, 248, 248)'}}>

    <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
       <div >
        <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>Qatamya Dunes</text>
          </div>

            </div>
        <div style={{marginLeft:500, width:'50%'}}>
            <CardItem
              src={dunesJpg}
              text='Underfloor'
              path='/projects'
            />
            </div>
            </div>

            <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
       <div >
        <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>Qatamya Dunes</text>
          </div>

            </div>
        <div style={{marginLeft:500, width:'50%'}}>
            <CardItem
              src={dunes2Jpg}
              text='Radiators'
              path='/projects'
            />
            </div>
            </div>

            <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>

            <div >
            <div style={{padding:25 }}>
            <text style={{ fontSize:24}}>Beverly Hills</text>
            </div>

     </div>
<div style={{marginLeft:530, width:'50%'}}>
     <CardItem
       src={beverlyHillsJpg}
       text='Control'
       path='/projects'
     />
     </div>
     </div>

     <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>

<div >
<div style={{padding:25 }}>
   <text style={{ fontSize:24}}>Qatamya Heights</text>
   </div>

     </div>
<div style={{marginLeft:480, width:'50%'}}>
     <CardItem
       src={qatamyaHeightsJpg}
       text='Solar Heater'
       path='/projects'
     />
     </div>
     </div>

     <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>

<div >
<div style={{padding:25 }}>
   <text style={{ fontSize:24}}>ALLEGRIA SODIC</text>
   </div>

     </div>
<div style={{marginLeft:480, width:'50%'}}>
     <CardItem
       src={heightsJpg}
       text='Domestic Hot Water'
       path='/projects'
     />
     </div>
     </div>

     <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>

<div >
<div style={{padding:25 }}>
   <text style={{ fontSize:24}}>Sheikh Zayed</text>
   </div>

     </div>
<div style={{marginLeft:510, width:'50%'}}>
     <CardItem
       src={domesticControlRoomJpg}
       text='Domestic ControlRoom'
       path='/projects'
     />
     </div>
     </div>
     <section id="contact">
      <Footer />
      </section>
    </div>
    </>
  );
}

export default laptopProjects;